<script setup lang="ts">
import { UIIcon } from '@groover-dev/groover-ui'

type Props = {
  size?: InstanceType<typeof UIIcon>['size']
  sizeOverride?: `${number}px`
}

const props = withDefaults(defineProps<Props>(), {
  size: 'base',
  sizeOverride: undefined,
})

const style = computed(() => {
  if (props.sizeOverride) {
    return {
      width: `${props.sizeOverride}`,
      height: `${props.sizeOverride}`,
    }
  }
  return {}
})

const sizeAttrs = computed(() =>
  props.sizeOverride
    ? {
        height: props.sizeOverride,
        width: props.sizeOverride,
      }
    : {},
)
</script>

<script lang="ts">
/**
 * Displays the Groover logo icon.
 */
export default {}
</script>

<template>
  <UIIcon
    name="groover:logo"
    class="tw-text-icon-brand"
    :size
    :style
    v-bind="sizeAttrs"
  />
</template>
